/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DocumentSigned/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DocumentSigned({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/DocumentSigned"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.100'
        })
  return (<React.Fragment
>
<div
  data-testid="DocumentSigned.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-DQvRA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-DQvRA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-DQvRA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-4-DQvRA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-DQvRA': dtColorsNeutral200,'--bc-6-DQvRA': dtColorsBlue100}}
 className={`views-block ${styles.Horizontal}`}
>
<No
  viewPath={`${viewPath}/No`}
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
</div>
{children}
</React.Fragment>)
}